// extracted by mini-css-extract-plugin
export var container = "index-module--container--1jUBW";
export var feature = "index-module--feature--8xwJE";
export var featureImage = "index-module--featureImage---mb60";
export var featureSubtitle = "index-module--featureSubtitle--AtTEO";
export var featureTitle = "index-module--featureTitle--06op7";
export var features = "index-module--features--ipGdT";
export var talkToSales = "index-module--talkToSales--AGIsa";
export var title = "index-module--title--ajR0V";
export var tts = "index-module--tts--TFFfL";